
import React, { useState, useEffect } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { lightTheme, darkTheme } from './theme';
import AppRoutes from './Routes';
import Layout from './components/common/Layout';
// import WelcomePage from './pages/landing/WelcomePage';
import { AlertProvider } from './contexts/AlertContext';
import IdleTimer from './components/common/IdleTimer';

const App = () => {
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    localStorage.setItem('darkMode', !darkMode);
  };

  useEffect(() => {
    const savedMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(savedMode);
  }, []);

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <IdleTimer />
            <Layout toggleDarkMode={toggleDarkMode} darkMode={darkMode}>
              <AlertProvider>
                <AppRoutes />
              </AlertProvider>
            </Layout>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
